import { render, staticRenderFns } from "./AudioEnter2.vue?vue&type=template&id=3e235210&scoped=true"
import script from "./AudioEnter2.vue?vue&type=script&lang=ts"
export * from "./AudioEnter2.vue?vue&type=script&lang=ts"
import style0 from "./AudioEnter2.vue?vue&type=style&index=0&id=3e235210&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e235210",
  null
  
)

export default component.exports